import { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';
import { useAuthUserContext } from '@/modules/auth';
import { isBetaTenant } from '@/config/tenant-features';

interface RequireBetaTenantProps extends PropsWithChildren {
  redirectTo?: string;
}

export const RequireBetaTenant: FunctionComponent<RequireBetaTenantProps> = ({ children, redirectTo = '/app' }) => {
  const { tenantId } = useAuthUserContext();

  if (!isBetaTenant(tenantId)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
